module.exports = __webpack_public_path__ + "static/media/mastercard.e1efc600.png";